import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from './classes/BaseService';
import { HttpClient } from "@angular/common/http";

@Injectable()
export class EventService extends BaseService{

  apiUrl: string = "Event.php?";

  constructor(protected http: HttpClient) {
    super(http);
  }

  newMailClick(store: string, country: string, clickId: string) {
    let url = this.serverUrl + this.apiUrl;
    let params = this.buildUrlParams(
      new UrlParam("store", store),
      new UrlParam("country", country),
      new UrlParam("eventType", "mailClick"),
      new UrlParam("clickId", clickId)
    );
    return this.post(url, params);
  }

}
